// extracted by mini-css-extract-plugin
export default {"myClaimsTable":"MyClaimsTable_myClaimsTable__tEu26","myClaimActions":"MyClaimsTable_myClaimActions__kiF4p","sortingIcon":"MyClaimsTable_sortingIcon__Cl3t9"};